import { Component, OnInit, TemplateRef, ChangeDetectorRef, AfterViewInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global"; 
import { HttpClient, HttpParams } from "@angular/common/http";
import { DatePipe } from "@angular/common" 
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import * as CONSTANT from "../../../services/constants"
import * as Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsSolidGauge from "highcharts/modules/solid-gauge"
import { ExcelService } from "src/app/services/excel.service";
import { ngxCsv } from 'ngx-csv/ngx-csv';

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);

@Component({
  selector: "app-inventory-usage",
  templateUrl: "./inventory-usage.component.html",
  styleUrls: ["./inventory-usage.component.css"]
})
export class InventoryUsageComponent implements OnInit, AfterViewInit {
  Highcharts: typeof Highcharts = Highcharts;
  public userDatas: any;
  allData:any;
  inventoryList : any = []
 
  inventoryUsedByMonthLable : any = []
  inventoryUsedByMonthValue : any = [] 
  top6InventoryUsedByUser : any = []
  
  color= ["#AF6F50","#8FAD51","#AF7B48","#4F4F7E","#A75050","#A28D55","#8B8B8B","#517595","#935A91","#D8905E","#4D7DAD","#51ACAC",]

  currentPage:any;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  maxDate: Date;
  today: Date;
  invalidDateFilter = false;
  fromDate: any;
  toDate: any;
  show = 0;
  filterForm: FormGroup;
  customRangeForm: FormGroup;
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  showError = false;
  noDataFound = false;
  filterValue:any;
  yearSub?: Date;
  yearLable = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  dayLabel = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  initialTableHeaders = ["User Email", "Name"]
  lastTableHeaders = ["Total", "Grand Total"]
  lastTableHeadersForTotal = ["Total Inventory"]
  tableGrandTotalLine : any = []
  tableGrandTotalLineForTotal : any = []
  monthLable:any;
  titleType:any = 5;
  tableHeaders: any = [];
  dateRange: any = [];
  // satrt weeks
  startdateofweek: any;  
  Enddateofweek: any;
  downloadData:any=[];
  csvData:any=[];    
  totalAvailableInventory:any;
  constructor( public route: ActivatedRoute,  private router: Router, private api: AdminService, public datePipe: DatePipe, private formBuilder: FormBuilder,private modalService: BsModalService, private ref:ChangeDetectorRef,private excelService:ExcelService) {  
    this.filterForm = this.formBuilder.group({
      startDate: new FormControl("", [Validators.required]),
      endDate: new FormControl("", [Validators.required]),
    });
    this.customRangeForm = this.formBuilder.group({
      startDate: new FormControl("", [Validators.required]),
      endDate: new FormControl("", [Validators.required]),
    });
    this.today = new Date();
    this.maxDate = new Date(this.today.getDate() + 3);
  }
  ngAfterViewInit(): void {
    // this.createChartColumn();
    // this.ref.detectChanges()
  }
  ngOnInit(): void {
    this.getDashboard(); 
    this.prepareTableHeaders(null); 
    this.getInventoryList(5,0); 
    // setTimeout(() => {
    //   this.createChartColumn();
    // }, 2000);
    this.ref.detectChanges() 
  }
   
  getDashboard(){
    let params = new HttpParams();
    if (this.fromDate) {
      params = params.append("startDate", this.fromDate);
    }
    if (this.toDate) {
      params = params.append("endDate", this.toDate);
    } 
    this.api.getData(apiUrl._inventoryUsage,params)
    .subscribe(async (res) => { 
      this.inventoryUsedByMonthLable=[]
      this.inventoryUsedByMonthValue=[]
      this.top6InventoryUsedByUser=[]
      this.allData = res.data;  
      this.totalAvailableInventory = this.allData?.totalInventoryPlan!=0?(this.allData?.totalInventoryPlan - this.allData?.totalInvetoryUsed):this.allData?.totalInvetoryUsed;  
      this.noDataFound = true;
      for (let inventory of this.allData.inventoryUsedByMonth) {
        if(inventory.count > 0){
          this.noDataFound = false
        }
        this.inventoryUsedByMonthLable.push(inventory.month);
        this.inventoryUsedByMonthValue.push(inventory.count);
      } 
      for (let data of this.allData.top6InventoryUsedByUser) {
        if(data.count > 0){
          this.noDataFound = false
        }
        this.top6InventoryUsedByUser.push({
          name: data.recruiter?.name,
          y: data.count,
        });
      }
      
    this.createChartColumn();
    this.ref.detectChanges()
    })
  } 
  getInventoryList(type?:any,date?:any){
    this.titleType = type;
    let params = new HttpParams();
		if(type == "1"){
		params = params.append("date", date );
    params = params.append("type", 1 );
		} else if(type == "2"){
		params = params.append("date", date );
    params = params.append("type", 2 );
		} else if(type == "3"){
      params = params.append("date", date );
			params = params.append("type", 3 );
		} else if(type == "4"){
			params = params.append("type", 4);
      params = params.append("startDate", this.dateRange[0]);
      params = params.append("endDate", this.dateRange[1]);
		} else{
		  params = params.append("type", 5 );
    }
    this.api.getData(apiUrl._inventoryUsageUser,params)
    .subscribe(async (res) => { 
      this.prepareTableHeaders(date)
      this.pagination.totalItems = res.data.count; 
      this.tableGrandTotalLine = [];
      this.inventoryList=[];
      res.data.data?.map((userData)=>{
        this.inventoryList.push(this.getRowData(userData, date));
      })
      // this.csvData.push(this.inventoryList); 
      if (this.inventoryList.length > 0) {
        for (let i=0; i < this.inventoryList[0].length; i++) {
          if (i < 2) {
            if (i == 0) {
              this.tableGrandTotalLine.push("Grand Total")  
            } else{
              this.tableGrandTotalLine.push("-")
          }
          } else {
            let total = 0
            for (let item of this.inventoryList) {
              total += Number(item[i])
            } 
            this.tableGrandTotalLine.push(total) 
            
          }
        }
      }
    })
  }  
  getRowData(userData, date) {
    let rowData : any = []
    rowData.push(userData.email)
    rowData.push(userData.name)
    if (this.titleType == 1) {
      let yearlyRowDataObj;
      for (let i=1; i<= 12; i++) {
        if (i < 10){
          yearlyRowDataObj = {
            ...yearlyRowDataObj,
            ["0" + i]: 0
          }
      } else {
        yearlyRowDataObj = {
          ...yearlyRowDataObj,
          [i]: 0
        }
      }
      }
      userData.recruiter_use_inventory_plan.map((data) => {
        yearlyRowDataObj[data.month] = data.count.toString()
      })
      for(let i=1; i <= 12; i++) {
        if (i < 10){
          rowData.push(yearlyRowDataObj["0" + i.toString()]);
        } else {
          rowData.push(yearlyRowDataObj[i.toString()]);
        }
      }
      
    rowData.push(userData.total)
    rowData.push(userData.grandTotal)
    } else if(this.titleType == 2) {
      let yearlyRowDataObj;
      let selectedDate = new Date(date)
      let maxNumberOfDays = new Date(selectedDate.getFullYear(), selectedDate.getMonth()+1, 0).getDate();
      for (let i=1; i <= maxNumberOfDays; i++) {
        let dateChecking = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), i);
        let key = this.datePipe.transform(dateChecking, "YYYY-MM-dd")?.toString()
        yearlyRowDataObj = {
          ...yearlyRowDataObj,
          [key ? key : "?"]: 0
        }
      }
      userData.recruiter_use_inventory_plan.map((data) => {
        yearlyRowDataObj[data.date] = data.count.toString()
      })
      for(let i=1; i <= maxNumberOfDays; i++) {
        let dateChecking = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), i);
        let key = this.datePipe.transform(dateChecking, "YYYY-MM-dd")?.toString()
        rowData.push(yearlyRowDataObj[key ? key : "?"]);
      }
      
    rowData.push(userData.total)
    rowData.push(userData.grandTotal)
    } else if(this.titleType == 3) {
      let yearlyRowDataObj = this.getWeekDates(date);
      userData.recruiter_use_inventory_plan.map((data) => {
        yearlyRowDataObj[data.date] = data.count.toString()
      })
      let sun = yearlyRowDataObj["initialDate"];
      let initalDate = new Date(sun ? sun : "");
      for(let i=0; i < 7; i++) {
        let checkingDate = new Date()
        checkingDate.setDate(initalDate.getDate() + i)
        let key = this.datePipe.transform(checkingDate, "YYYY-MM-dd")?.toString()
        rowData.push(yearlyRowDataObj[key ? key : "?"]);
      }
      
    rowData.push(userData.total)
    rowData.push(userData.grandTotal)
    } else if (this.titleType == 4) {
      // custom range
      let yearlyRowDataObj;
      let selectedDate = new Date(this.dateRange[0])
      let endDate = new Date(this.dateRange[1]);
      let maxDays = Math.floor((Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()) - Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()) ) /(1000 * 60 * 60 * 24)) + 1;
      for (let i=0; i < maxDays; i++) {
        let startDate = new Date(selectedDate);
        startDate.setDate(startDate.getDate() + i)
        // let dateChecking = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), i);
        let key = this.datePipe.transform(startDate, "YYYY-MM-dd")?.toString()
        yearlyRowDataObj = {
          ...yearlyRowDataObj,
          [key ? key : "?"]: 0
        }
      }
      userData.recruiter_use_inventory_plan.map((data) => {
        yearlyRowDataObj[data.date] = data.count.toString()
      })
      for(let i=0; i < maxDays; i++) {
        let startDate = new Date(selectedDate);
        startDate.setDate(startDate.getDate() + i)
        let key = this.datePipe.transform(startDate, "YYYY-MM-dd")?.toString()
        rowData.push(yearlyRowDataObj[key ? key : "?"]);
      }
      
    rowData.push(userData.total)
    rowData.push(userData.grandTotal)
    } else if (this.titleType == 5) {
      rowData.push(userData.total) 
    }
    return rowData;
  }
     
  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getInventoryList(0,0);
  }

  // hightchart 
 
  private createChartColumn(): void { 
    const chart= Highcharts.chart("chart-column" as any, {
      color: ["#4D7DAD","#51ACAC","#AF6F50","#8FAD51","#AF7B48","#4F4F7E","#A75050","#A28D55","#8B8B8B","#935A91"],
      chart: {
        type: "column"
      },
      title: {
        text: ""
      },
      xAxis: {
        type: "category",
        categories: this.inventoryUsedByMonthLable,
      },
      yAxis: {
        min: 0,
        title: "",
        labels: {
          overflow: "justify"
        }
      }, 
      plotOptions: {
        column: {
          colorByPoint: true,
          dataLabels: {
            enabled: true
          }
        }
      },
      legend: {
        enable: false
      },
      credits: {
        enabled: false
      },
      series: [
        {
          name: "Inventory used by month",
          data: this.inventoryUsedByMonthValue}
      ]
    
      } as any);
    const chart1 = Highcharts.chart("bar-Horizontal" as any, {
      
    color: ["#4D7DAD","#51ACAC","#AF6F50","#8FAD51","#AF7B48","#4F4F7E","#A75050","#A28D55","#8B8B8B","#935A91"],
    chart: {
      type: "bar"
    },
    title: {
      text: ""
    },
    xAxis: {
      type: "category",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    yAxis: {
      min: 0,
      title: "",
      labels: {
        overflow: "justify"
      }
    }, 
    plotOptions: {
      bar: {
        colorByPoint: true,
        dataLabels: {
          enabled: true
        }
      }
    },
    legend: {
      enable: false
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: "Inventory used by recruiter",
        type: "bar",
        barWidth: "60%",
        data: this.top6InventoryUsedByUser,}
    ]
  
    } as any); 
  }
filterInventory(event:any){
  this.filterValue =event.target.value;
    if(this.filterValue == "1"){
      this.onOpenCalendar(1)
    }
    if(this.filterValue == "2"){
      this.onOpenCalendar(2);
    }
    if(this.filterValue == "3"){
      this.onOpenCalendar(3);
    }
    if( this.filterValue == "4"){
      this.onOpenCalendar(4);
    }
    if(this.filterValue == "5"){
      this.getInventoryList(this.filterValue);
    }
}
 
goToYear(event:any){
  let year = this.datePipe.transform(event,"yyyy");
  if(year){
    this.getInventoryList("1",year);
  }
}

// month cal
goToMonth(event:any){
  let month = this.datePipe.transform(event,"YYYY-MM-dd");
  if(month){
    this.getInventoryList("2",month);
  }
} 
// week cal
goToWeek(event:any){
  let date = this.datePipe.transform(event,"YYYY-MM-dd");
  if(date){
    this.getInventoryList("3",date);
  }
} 

getWeekDates(event) {
  let initalDate = new Date(event)
  let getdate:any = this.datePipe.transform(initalDate, "yyyy,M,d");  
    function startOfWeek(date) {  
      var diff = date.getDate() - date.getDay();  
      return new Date(date.setDate(diff));  
    }
    function endofweek(date) {  
      var lastday = date.getDate() - (date.getDay()) + 6;  
      return new Date(date.setDate(lastday));  
    } 
    
    var dt = new Date(getdate);  
    this.startdateofweek= this.datePipe.transform(startOfWeek(dt),"EEEE, MMMM d, y");  
    this.Enddateofweek=this.datePipe.transform(endofweek(dt),"EEEE, MMMM d, y");  
  
    function addDays(date, days) {  
      const find = new Date(Number(date))  
      find.setDate(date.getDate() + days)  
      return find  
    }
    const date = new Date(startOfWeek(dt));  

    let sun = this.datePipe.transform(startOfWeek(dt), "YYYY-MM-dd"); 
    let mon = this.datePipe.transform(addDays(date, 1), "YYYY-MM-dd");  
    let tue = this.datePipe.transform(addDays(date, 2), "YYYY-MM-dd");  
    let wed = this.datePipe.transform(addDays(date, 3), "YYYY-MM-dd");  
    let thu = this.datePipe.transform(addDays(date, 4), "YYYY-MM-dd");  
    let fri = this.datePipe.transform(addDays(date, 5), "YYYY-MM-dd");  
    let sat = this.datePipe.transform(endofweek(dt), "YYYY-MM-dd");  
    
    let weekObj = {
      [sun ? sun : "?"]: 0,
      [mon ? mon : "?"]: 0,
      [tue ? tue : "?"]: 0,
      [wed ? wed : "?"]: 0,
      [thu ? thu : "?"]: 0,
      [fri ? fri : "?"]: 0,
      [sat ? sat : "?"]: 0,
      "initialDate" : sun
    } 
    
    return weekObj;
}

onOpenCalendar(container:any) {
  container.yearSelectHandler = (event: any): void => {
    container._store.dispatch(container._actions.select(event.date));
  };
}
// custom range cal
goToRange(event:any){
  this.dateRange = [];
  let range:any = this.datePipe.transform(event[0],"YYYY-MM-dd");
  let range1:any = this.datePipe.transform(event[1],"YYYY-MM-dd");
  this.dateRange.push(range,range1)
  if(event != ""){
    this.getInventoryList("4",this.dateRange);
  } else{
    this.dateRange = ["",""]
  }
}  
  openModal(Filter: TemplateRef<any>) {
    this.modalService.show(Filter);
  }
  close() {
    this.modalRef?.hide();
  }
  
  applyFilter(modal: any) {
    this.fromDate = this.datePipe.transform(
      this.filterForm.value.startDate,
      "yyyy-MM-dd"
    );
    this.toDate = this.datePipe.transform(
      this.filterForm.value.endDate,
      "yyyy-MM-dd"
    );
    if (this.filterForm.valid) {
      if (this.fromDate && this.toDate) {
        if (this.fromDate > this.toDate) {
          this.invalidDateFilter = true;
          setTimeout(() => {
            this.invalidDateFilter = false;
          }, 4000);
          return;
        }
      }
      this.getDashboard();
      this.show = 1;
      this.modalService.hide();
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 3000);
      return;
    }
  } 

  clearFilter(modal: any) {
    this.filterForm.reset();
    this.fromDate = "";
    this.toDate = "";
    this.show = 0;
    this.modalRef?.hide();
    this.modalService.hide();
    this.getDashboard();
  }

  prepareTableHeaders(date) {
    this.tableHeaders=[]
    this.initialTableHeaders.map((i) => {
      this.tableHeaders.push({"title":i});
    })

    if (this.titleType == 1) {
      this.yearLable.map((i) => {
        this.tableHeaders.push({"title":i});
      })
      
    this.lastTableHeaders.map((i) => {
      this.tableHeaders.push({"title":i});
    })
    } else if(this.titleType == 2) {
      // dates
      let selectedDate = new Date(date)
      let maxNumberOfDays = new Date(selectedDate.getFullYear(), selectedDate.getMonth()+1, 0).getDate();
      console.log("maxDays",maxNumberOfDays);
      for (let i=1; i <= maxNumberOfDays; i++) {
        let dateChecking = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), i);
        let key = this.datePipe.transform(dateChecking, "dd/MM")?.toString()
        this.tableHeaders.push({"title": key});
      }
      
    this.lastTableHeaders.map((i) => {
      this.tableHeaders.push({"title":i});
    })
    } else if(this.titleType == 3) {
      this.dayLabel.map((i) => {
        this.tableHeaders.push({"title":i});
      })
      
    this.lastTableHeaders.map((i) => {
      this.tableHeaders.push({"title":i});
    })
    } else if (this.titleType == 4) {
      let selectedDate = new Date(this.dateRange[0])
      let endDate = new Date(this.dateRange[1]);
      let maxDays = Math.floor((Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()) - Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()) ) /(1000 * 60 * 60 * 24)) + 1;
      for (let i=0; i < maxDays; i++) {
        let startDate = new Date(selectedDate);
        startDate.setDate(startDate.getDate() + i)
        let key = this.datePipe.transform(startDate, "dd/MM")?.toString()
        this.tableHeaders.push({"title": key});
      }
      
    this.lastTableHeaders.map((i) => {
      this.tableHeaders.push({"title":i});
    })
    }else if (this.titleType == 5) {
      this.lastTableHeadersForTotal.map((i) => {
        this.tableHeaders.push({"title":i});
      }) 
    }
  }
  // download
  downloadReport(){
    let tableTitle:any = [];
    for(let i= 0; i < this.tableHeaders.length; i++){
      tableTitle.push(this.tableHeaders[i].title)
    }
    var options = {
      showLabels: false,
      showTitle: false,
      useBom: false,
      headers: tableTitle
    };
    new ngxCsv(this.inventoryList, "Inventory usage by users",options);
  } 
}
